import React from 'react'

import { RewardProgramWidget } from '@pages/RewardsHub/RewardProgramWidget'
import { useRewardPrograms } from '@pages/RewardsHub/hooks/useRewardPrograms'

export const RewardPrograms: React.FC = () => {
  const { rewardPrograms } = useRewardPrograms()

  if (rewardPrograms?.items?.length === 0) {
    return null
  }

  return rewardPrograms?.items?.map((rewardProgram) => (
    <RewardProgramWidget key={rewardProgram.id} rewardProgram={rewardProgram} />
  ))
}
